<template>
  <div class="home-slider-wrap" v-bind:class="{ 'edit-mode': edit == 'true' }">
    <div class="container-fluid">
    <div class="row">
      <div class="col-12" v-bind:class="{'col-md-9': !kobler}">
        <swiper :pagination="true" class="mySwiper" @swiper="onSwiper" @slideChange="onSlideChange">
          <swiper-slide v-for="(d, k) in data.slider" :key="objId(d, k)">
            <div class="image">
              <picture>
                <source media="(min-width:1400px)" :srcset="resizeImage(d.img, 1200, 1200)">
                <source media="(min-width:1200px)" :srcset="resizeImage(d.img, 1020, 1020)">
                <source media="(min-width:992px)" :srcset="resizeImage(d.img, 870, 870)">
                <source media="(min-width:768px)" :srcset="resizeImage(d.img, 710, 710)">
                <img :src="resizeImage(d.img, 768, 768)" alt="" class="m-image-auto m-auto img-responsive">
              </picture>
            </div>
            <input style="top: 10px; left: 40px; position: absolute;" type="checkbox" v-if="edit == 'true'" v-model="d.show" @click="d.show = !d.show">
            <div class="contents" v-if="d.show">
              <div class="label" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editText1($event)">
                {{ d.text1 }}
              </div>
              <div class="heading" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editText2($event)">{{
                d.text2 }}</div>
              <div class="subheading" :contenteditable="edit == 'true' ? 'true' : 'false'"
                v-on:blur="editText3($event)">{{ d.text3 }}</div>
              <div class="texts">
                <div class="text">
                  <p :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editText4($event)">{{ d.text4 }}
                  </p>
                </div>
              </div>
              <div><a class="btn btn-primary btn-lg" href="#">Xem ngay</a></div>
            </div>

          </swiper-slide>
        </swiper>

      </div>
      <div class="col-12 col-md-3" v-if="!kobler">
        <div class="slider-wrap-2">
          <div class="slider-2">
            <div class="banner-image">
              <a v-if="edit == 'true'" href="javascript:void(0)">
                <img alt="banner-01" src="/image/catalog/demo/theme/top-banner-01.jpg">
              </a>
              <a v-if="edit != 'true'" href="#">
                <img alt="banner-01" src="/image/catalog/demo/theme/top-banner-01.jpg">
              </a>
            </div>
            <div class="content">
              <div class="cms-label" v-if="data.hot1.hot">hot</div>
              <h3 class="title" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editHot1Text1($event)">
                {{ data.hot1.text1 }}
              </h3>
              <span class="subheading" :contenteditable="edit == 'true' ? 'true' : 'false'"
                v-on:blur="editHot1Text2($event)">{{ data.hot1.text2 }}</span>

              <h3 class="price" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editHot1Text3($event)">
                {{ data.hot1.text3 }}</h3>
              <span class="old-price" :contenteditable="edit == 'true' ? 'true' : 'false'"
                v-on:blur="editHot1Text4($event)">
                {{ data.hot1.text4 }}</span>
            </div>
          </div>
          <div class="slider-3 dark">
            <div class="banner-image"><a href="#"><img alt="banner-01"
                  src="image/catalog/demo/theme/top-banner-02.jpg"></a></div>
            <div class="content">
              <div class="cms-label" v-if="data.hot2.hot">hot</div>
              <h3 class="title" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editHot2Text1($event)">
                {{ data.hot2.text1 }}
              </h3>
              <span class="subheading" :contenteditable="edit == 'true' ? 'true' : 'false'"
                v-on:blur="editHot2Text2($event)">{{ data.hot2.text2 }}</span>

              <h3 class="price" :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editHot2Text3($event)">
                {{ data.hot2.text3 }}</h3>
              <span class="old-price" :contenteditable="edit == 'true' ? 'true' : 'false'"
                v-on:blur="editHot2Text4($event)">
                {{ data.hot2.text4 }}</span>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
  </div>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default {
  props: ["edit", "data", "kobler"],
  data() {
    return {
      swiper: null,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    console.log(this.data);
    document.execCommand("styleWithCSS", 0, true);
  },
  methods: {
    resizeImage(link, width, height) {
      const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
      if (test) {
        // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
        return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
      } else {
        return link;
      }
    },
    boldText() {
      console.log("boldText");
      document.execCommand("bold");
    },
    objId(d, k) {
      return d.img + k;
    },
    editHot1Text1(event) {
      let t = this;
      t.data.hot1.text1 = event.target.innerText;
    },
    editHot1Text2(event) {
      let t = this;
      t.data.hot1.text2 = event.target.innerText;
    },
    editHot1Text3(event) {
      let t = this;
      t.data.hot1.text3 = event.target.innerText;
    },
    editHot1Text4(event) {
      let t = this;
      t.data.hot1.text4 = event.target.innerText;
    },
    editHot2Text1(event) {
      let t = this;
      t.data.hot2.text1 = event.target.innerText;
    },
    editHot2Text2(event) {
      let t = this;
      t.data.hot2.text2 = event.target.innerText;
    },
    editHot2Text3(event) {
      let t = this;
      t.data.hot2.text3 = event.target.innerText;
    },
    editHot2Text4(event) {
      let t = this;
      t.data.hot2.text4 = event.target.innerText;
    },
    editText1(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].text1 = event.target.innerText;
    },
    editText2(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].text2 = event.target.innerText;
    },
    editText3(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].text3 = event.target.innerText;
    },
    editText4(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].text4 = event.target.innerText;
    },
    editButtonText(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].button1.text = event.target.innerText;
    },
    editButtonLink(event) {
      let t = this;
      t.data.slider[this.swiper.realIndex].button1.link = event.target.innerText;
    },
    removeCurrentSlide() {
      let t = this;
      if (typeof t.data.slider[t.swiper.realIndex] != "undefined") {
        t.data.slider.splice(t.swiper.realIndex, 1);
      }
    },
    changeImage(src) {
      console.log(this.swiper.realIndex);
      let t = this;
      t.data.slider[this.swiper.realIndex].img = src;
      console.log(src);
    },
    addObject() {
      let t = this;
      t.data.slider.push({
        "show": true,
        "img": "/images/slider/bep-gon-gang.png",
        "text1": "25% OFF",
        "text2": "Bếp gọn gàng - ngập tràn hứng khởi",
        "text3": "Giá chỉ từ",
        "text4": "2,400,000 VNĐ",
        "button1": {
          "text": "Xem ngay",
          "link": "#"
        }
      });
      console.log(this.swiper);
      if (this.swiper) {
        setTimeout(() => {
          t.swiper.slideTo(t.data.slider.length - 1);
        }, 500);
      }
    },
    slideStyle(img) {
      return (
        "background: url('" +
        img +
        "') center center no-repeat;background-size: cover;"
      );
    },

    onSwiper(swiper) {
      this.swiper = swiper;
    },
  },
  setup() {
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSlideChange,
    };
  },
};
</script>
<style lang="less" scope="this api replaced by slot-scope in 2.5.0+">
.home-slider-wrap {
  .swiper {
    border-radius: 10px;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      .image {
        img {
          width: 100%;
          height: auto;
        }
      }

      >.contents {
        position: absolute;
        top: 14%;
        left: 0;
        z-index: 100;
        width: 45%;
        left: 5%;
        text-align: left;
        transform: scale(0.6);
        transition: transform 1s;

        .label {
          font-size: 11px;
          line-height: 12px;
          margin-bottom: 3px;
          text-transform: uppercase;
          color: white;
        }

        .heading {
          font-size: 14px;
          line-height: 18px;
          font-weight: 600;
          -webkit-margin-after: 18px;
          margin-block-end: 0;
          text-transform: capitalize;
          color: white;
          letter-spacing: 1px;
        }

        .subheading {
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: white;
          display: none;
        }

        .texts {
          .text {
            p {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              line-height: 25px;
              font-size: 22px;
              margin-bottom: 2px;
              margin-top: 2px;
              color: #11a859;
              justify-content: left;
              letter-spacing: 1px;
            }
          }
        }

        .btn {
          background: #f25c05;
          color: white;
          padding: 10px 28px;
          font-weight: 600;
          font-size: 11px;
          line-height: 1.5;
          padding: 5px 15px;
          border: none;
        }
      }

      &.swiper-slide-active {
        >.contents {
          transform: scale(1);
        }
      }
    }

  }

  .slider-wrap-2 {
    height: 30vw;
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding-top: 20px;

    .slider-2,
    .slider-3 {
      border-radius: 10px;
      overflow: hidden;
      position: relative;

      .banner-image {
        width: 100%;
        height: 100%;
        overflow: hidden;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .content {
        position: absolute;
        top: 10%;
        left: 15px;
        right: auto;
        color: white;
        text-align: left;

        h3.title {
          margin-bottom: 6px;
          font-size: 14px;
          line-height: 22px;
          width: 72%;
          font-weight: 700;
        }

        .subheading,
        .cms-label {
          display: none;
        }

        .cms-label {
          background: #11a859;
          padding: 0px 12px;
          width: auto;
          float: left;
          border-radius: 5px;
          color: white;
          text-transform: capitalize;
          margin-bottom: 15px;
        }

        .price {
          font-size: 18px;
          line-height: 20px;
          display: flex;
          justify-content: space-between;

          >span {
            display: inline-block;
          }
        }

        .old-price {
          text-decoration: line-through;
          display: none;
        }
      }

      &.dark {
        .content {
          color: black;

        }
      }
    }

    .slider-2 {
      flex: 1;
      background-color: #f26919;

    }

    .slider-3 {
      flex: 1;
      background-color: #e0f1fb;
    }
  }
  &.edit-mode {
    .slider-wrap-2 {
      .slider-2, .slider-3 {
        .content {
          .title, .subheading, .price, .old-price {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }

        }
      }
    }
    .swiper {
      .swiper-slide {
        >.contents {
          width: 100% !important;
          .label, .heading, .subheading, .texts {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }
          .heading {
            font-size: 30px !important;
          }
        }
      }
    }
  }
}

@media (min-width: 600px) {
  .home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          .label {
            font-size: 13px;
            line-height: 14px;
            margin-bottom: 3px;
          }

          .heading {
            font-size: 20px;
            line-height: 20px;
            font-weight: 600;
            -webkit-margin-after: 18px;
            margin-block-end: 0;
            color: white;
          }

          .subheading {
            font-size: 15px;
            font-weight: 400;
            line-height: 28px;
            display: block;
          }

          .texts {
            .text {
              p {
                line-height: 34px;
                font-size: 34px;
                margin-bottom: 8px;
                margin-top: 4px;
                letter-spacing: 1px;
              }
            }
          }

          .btn {
            font-weight: 600;
            font-size: 15px;
            line-height: 1.5;
            padding: 8px 15px;
          }
        }
      }

    }
  }



}


@media (min-width: 992px) {
  .home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          .label {
            font-size: 13px;
            line-height: 20px;
            margin-bottom: 6px;
          }

          .heading {
            font-size: 32px;
            line-height: 38px;
            margin-block-end: 6px;
            margin-block-end: 0;
            color: white;
          }

          .subheading {
            -webkit-margin-after: 15px;
            margin-block-end: 15px;
            font-size: 14px;
            line-height: 18px;
          }

          .texts {
            .text {
              p {
                line-height: 42px;
                font-size: 38px;
                margin-bottom: 15px;
                margin-top: 18px;
              }
            }
          }

          .btn {
            font-size: 13px;
            line-height: 22px;
            line-height: 1.5;
            padding: 6px 18px;
          }
        }
      }

    }
  }


}

@media (min-width: 1200px) {
  .home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 20%;

          .label {
            font-size: 18px;
            margin-bottom: 15px;
          }

          .heading {
            font-size: 48px;
            line-height: 54px;
            font-weight: 600;
            margin-block-end: 18px;
            color: white;
          }

          .subheading {
            font-size: 14px;
            font-weight: 400;
            line-height: 28px;
          }

          .texts {
            .text {
              p {
                font-size: 42px;
                font-weight: 500;
                line-height: 44px;
                margin-top: 5px;
                margin-bottom: 32px;
              }
            }
          }

          .btn {
            padding: 10px 28px;
            font-size: 14px;
            line-height: 24px;
          }
        }
      }

    }
  }



}


@media (min-width: 768px) {
  .home-slider-wrap {
    .slider-wrap-2 {
      padding-top: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .slider-2,
      .slider-3 {
        border-radius: 10px;
      }

      .slider-2 {
        flex: 1;
        background-color: #f26919;

      }

      .slider-3 {
        flex: 1;
        background-color: #e0f1fb;
      }
    }
  }
}

@media (min-width: 992px) {
  .home-slider-wrap {
    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          h3.title {
            line-height: 22px;
            margin-bottom: 10px;
            font-size: 18px;
          }

          .subheading {
            display: none;
          }

          .cms-label {
            display: block;
            margin-right: 100%;
            margin-bottom: 6px;
          }

          .price {
            font-size: 24px;
            line-height: 26px;
          }

          .old-price {
            display: inline-block;
          }
        }
      }
    }
  }

  #home-popular-categories {
    .stickyscroll {
      .scroll-item {
        width: 140px;

        .image {
          border-radius: 50%;
          width: 140px;
          height: 140px;
          overflow: hidden;

          img {
            max-width: 100%;
          }
        }
      }
    }
  }
}

@media (min-width: 1200px) {
  .home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 7%;
        }
      }
    }

    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          h3.title {
            line-height: 22px;
            margin-bottom: 5px;
            font-size: 18px;
          }

          .subheading {
            display: block;
            padding-bottom: 3px;
            font-size: 13px;
            line-height: 22px;
          }

          .cms-label {
            display: block;
            margin-bottom: 6px;
          }

          .price {
            font-size: 26px;
            line-height: 30px;
          }
        }
      }
    }
  }
}

@media (min-width: 1400px) {
  .home-slider-wrap {
    .swiper {
      .swiper-slide {
        >.contents {
          top: 13%;
        }
      }
    }

    .slider-wrap-2 {

      .slider-2,
      .slider-3 {
        .content {
          top: calc(50% - 80px);
        }
      }
    }
  }
}
</style>